import { render } from "./dutyStaticsList.vue?vue&type=template&id=58456cf2&scoped=true"
import script from "./dutyStaticsList.vue?vue&type=script&lang=js"
export * from "./dutyStaticsList.vue?vue&type=script&lang=js"

import "./dutyStaticsList.vue?vue&type=style&index=0&id=58456cf2&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58456cf2"]])

export default __exports__